export const REDUCER_NAME = "playerStatistics";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_PLAYERSTATISTICS = `${REDUCER_NAME}/SET_PLAYERSTATISTICS`;
export const RESET_PLAYERSTATISTICS = `${REDUCER_NAME}/RESET_PLAYERSTATISTICS`;
